// Components
import PaymentLoading from '../components/payment/paymentLoading.component';
import PaymentLoaded from '../components/payment/paymentLoaded.component';

import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { A1_POWEREDBY_COLOR_PRIMARY, EVENTS_URL } from '../config';
import { PaymentPageEventDocument } from '../graphql/graphql';
import { ThemeProvider } from '../ThemeProvider';
import { useContext, useEffect } from 'react';
import { CartContext } from '../components/providers/cart.tsx';
import useEventPixel from '../hooks/useEventPixel.tsx';
import { formatPrimaryColor } from '../utils/formatter.ts';

export default function PaymentPage() {
    const { t } = useTranslation();
    const { currentEventId } = useContext(CartContext);

    const { loading, data, error } = useQuery(PaymentPageEventDocument, {
        variables: {
            eventId: currentEventId!,
        },
        skip: !currentEventId,
    });

    const { trackEvent, initialized } = useEventPixel(currentEventId!);

    useEffect(() => {
        if (!currentEventId) {
            window.location.href = EVENTS_URL;
        }
    }, [currentEventId]);

    useEffect(() => {
        if (initialized) {
            trackEvent('CustomEvent', {
                event_label: 'payment_page_view',
                content_ids: [currentEventId],
            });
        }
    }, [initialized, currentEventId, trackEvent]);

    if (!loading && error) {
        return <>{t('paymentPage.errorLoadingData', 'Error Loading Data')}</>;
    }

    const organizerThemeColor = data?.event?.organizerColor || A1_POWEREDBY_COLOR_PRIMARY;

    const organizerPrimaryColor = formatPrimaryColor(
        data?.event?.eventType,
        data?.event?.organizerType,
        organizerThemeColor
    );

    return (
        <ThemeProvider>
            <>
                {loading ? (
                    <PaymentLoading />
                ) : (
                    <PaymentLoaded
                        event={data!.event}
                        organizerPrimaryColor={organizerPrimaryColor}
                        trackEvent={trackEvent}
                    />
                )}
            </>
        </ThemeProvider>
    );
}
